<template>
  <div
    :class="[
      `group group--contentful group--sidebar search`,
      state === `focus` ? `search--offset` : ``,
    ]"
  >
    <div :class="[`form-fieldset`, `form-fieldset--text`]">
      <div :class="[`form-fieldset__wrapper`, `form-fieldset__wrapper--text`]">
        <label
          :class="[`form-label`, `form-label--text`, `form-label--${state}`]"
          for="search"
        >
          <span class="form-label__label p">Start typing to search…</span>
        </label>

        <div
          :class="[`form-field`, `form-field--text`, `form-field--${state}`]"
        >
          <input
            :class="[`form-input`, `form-input--text`, `form-input--${state}`]"
            id="search"
            ref="input"
            v-model="search"
            @input="throttledSearch"
            @focus="onFocus"
            @blur="onBlur"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'contentful-search',

  // Data
  data() {
    return {
      search: '',
      focus: false,
    };
  },

  // Computed
  computed: {
    ...mapGetters('app', ['org']),

    state() {
      if (this.focus || this.search.length > 0) return 'focus';
      return 'idle';
    },
  },

  // Watchers
  watch: {
    org(org) {
      if (!org || !this.$route.query.search) return;

      this.executeSearch({
        parentCode: org.parent_code,
        query: this.$route.query.search,
      });
    },
  },

  // Methods
  methods: {
    ...mapActions('contentful', ['searchArticles']),

    onFocus() {
      this.focus = true;
    },

    onBlur() {
      this.focus = false;
    },

    throttledSearch: _.debounce(function (event) {
      // eslint-disable-line no-undef
      const { value } = event.target;

      if (value && value.length > 2) {
        /* eslint-disable-next-line no-invalid-this */
        const self = this;

        self.executeSearch({
          parentCode: self.org.parent_code,
          query: event.target.value,
        });
      }
    }, 500),

    executeSearch({ parentCode, query }) {
      this.searchArticles({
        parentCode,
        query,
      }).then(() => {
        if (this.$route.name !== 'search-results') {
          this.$router.push({
            name: 'search-results',
            query: {
              search: this.search,
            },
          });
        }
      });
    },
  },

  // Lifecycles
  created() {
    if (this.$route.query.search) {
      this.$set(this, 'search', this.$route.query.search);
    }
  },
};
</script>



// WEBPACK FOOTER //
// Search.vue?7206122e